module.exports = __webpack_public_path__ + "static/media/P7.ed3d8f24.png";